import {
  FETCH_SHARED_RESOURCE_START,
  FETCH_SHARED_RESOURCE_SUCCESS,
  FETCH_SHARED_RESOURCE_FAILED,
  UPDATE_SHARED_RESOURCE_STATUS,
} from 'legacy-src/constants/types';
import { fetchSharedResources } from '../utility/helpers';

export const getSharedResources = (requestData) => async (dispatch) => {
  dispatch({
    type: FETCH_SHARED_RESOURCE_START,
  });
  let resources;
  try {
    resources = await fetchSharedResources(requestData);
    dispatch({
      type: FETCH_SHARED_RESOURCE_SUCCESS,
      payload: resources,
    });
  } catch (error) {
    dispatch({
      type: FETCH_SHARED_RESOURCE_FAILED,
      payload: { errorMessage: error.message },
    });
  }

  return resources;
};

export const updateSharedResourceWatchStatus =
  (resourceId, watchStatus) => (dispatch) => {
    dispatch({
      type: UPDATE_SHARED_RESOURCE_STATUS,
      payload: { resourceId, watchStatus },
    });
  };
